module.exports = __webpack_public_path__ + "img/island-tropical.977434d4.svg";